import type { ReactNode } from 'react'

export interface PageHeaderProps {
  title: ReactNode
  breadcrumb?: ReactNode
  meta?: ReactNode
  actions?: ReactNode
}

export function PageHeader({ title, breadcrumb, meta, actions }: PageHeaderProps) {
  return (
    <header className="flex flex-wrap items-end justify-between gap-4">
      <div className="flex flex-col gap-1.5 min-w-0">
        {breadcrumb && <div className="text-[13px] text-muted">{breadcrumb}</div>}
        <h1 className="m-0 font-heading text-[28px] leading-tight font-bold tracking-[-0.02em] text-ink">{title}</h1>
        {meta && <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[13px] text-ink-secondary">{meta}</div>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </header>
  )
}
